import {EmailService} from '../email/email.service';
import {FetchService} from '../fetch/fetch.service';
import {ServiceDetailComponent} from '../services/service-detail/service-detail.component';

require('./services.scss');

new ServiceDetailComponent(new EmailService(new FetchService()));
